import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environments'
@Injectable({
  providedIn: 'root'
})
export class OpreatorsService {

  constructor(private http: HttpClient ) { }

  retriveOpreators(){
    return this.http.get(`${environment.baseUrl}/auth/operators`)
  }

  addopreators(data:any){
    return this.http.post(`${environment.baseUrl}/auth/register`,data)
  }

  editOpreators(data:any){
    return this.http.post(`${environment.baseUrl}/auth/edit`,data)
  }

  addroleForUser(data:any){
    return this.http.post(`${environment.baseUrl}/role/urv`,data)
  }
  addroleForUserandProject(data:any){
    return this.http.post(`${environment.baseUrl}/role/padmin`,data)
  }

  retiveLogs(data:any){
    return this.http.post(`${environment.baseUrl}/cards/operators/`,data)
  }
  exportLogs(data:any){
    return this.http.post(`${environment.baseUrl}/cards/operators_exports/`,data)
  }
}
